const STORAGE_KEY = 'hc-visume-feedback';

export function setVisumeFeedback(payload) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...payload, at: Date.now() }));
  } catch {
    /* ignore quota / private mode */
  }
}

export function consumeVisumeFeedback() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(STORAGE_KEY);
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
